import { render, staticRenderFns } from "./DecksTrade.vue?vue&type=template&id=2efaccec&"
import script from "./DecksTrade.vue?vue&type=script&lang=js&"
export * from "./DecksTrade.vue?vue&type=script&lang=js&"
import style0 from "./DecksTrade.vue?vue&type=style&index=0&id=2efaccec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports